import React from 'react';
import { connect } from 'react-redux';
import { Certificate, Loader } from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useLocalErrorHandler } from 'hooks';

const ExpertCertificateContainer = ({
    getCertificateList, certificateList, apiError, setErrorHandler,
}: Props) => {
    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await getCertificateList();
            setProcessing(false);
        };

        fetch();
    }, []);

    useLocalErrorHandler(setErrorHandler);

    if (processing) return <Loader />;

    return (
        <Certificate
          apiError={apiError}
          certificateList={certificateList}
          onlyWatch
          withBorder
        />
    );
};

const mapState = (state: IRootState) => ({
    certificateList: state.expert.certificateList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    getCertificateList: dispatch.expert.getCertificateListAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;

export default connect(mapState, mapDispatch)(ExpertCertificateContainer);
